import { useContext } from 'react';

import { ResourceOrderContext } from './resource-order-context';

export const useResourceOrder = () => {
  return useContext(ResourceOrderContext);
};
